<template>
 <div class="LH infinite-table-LH" v-if="this.tableData.length">
	<el-table :data='this.tableData[0].riskLociParams' stripe style="width: 100%" max-height="300" v-if="isLHAndRISK">
		<el-table-column prop="detectionItemNameCn" label="检测项" min-width="110">
		</el-table-column>
		<el-table-column prop="lowRiskThread" label="低风险门限" min-width="105">
		</el-table-column>
		<el-table-column prop="mediumRiskThread" label="中风险门限" min-width="105">
		</el-table-column>
		<el-table-column prop="highRiskThread" label="高风险门限" min-width="105">
		</el-table-column>
		<el-table-column prop="chrId" label="CHR_ID" min-width="105">
		</el-table-column>
		<el-table-column prop="chrPos" label="CHR_POS" min-width="105" >
		</el-table-column>
		<el-table-column prop="snps" label="SNPS" min-width="105">
		</el-table-column>
		<el-table-column prop="gene" label="Gene" min-width="80">
		</el-table-column>
		<el-table-column prop="refAlelle" label="Ref Alelle" min-width="85">
		</el-table-column>
		<el-table-column prop="snp" label="SNP" min-width="85">
		</el-table-column>
		<el-table-column prop="riskAllele" label="Risk Allele" min-width="105">
		</el-table-column>
		<el-table-column prop="riskHomo" label="Risk homo" min-width="105">
		</el-table-column>
		<el-table-column prop="riskHomoFreq" label="Risk homo freq" min-width="125">
		</el-table-column>
		<el-table-column prop="riskHomoOr" label="Risk homo OR" min-width="115">
		</el-table-column>
		<el-table-column prop="resultHomo" label="检测结果Risk homo OR" min-width="180">
		</el-table-column>
		<el-table-column prop="riskHomoRiskM" label="Risk homo risk (M)" min-width="145">
		</el-table-column>
		<el-table-column prop="riskHomoOrM" label="Risk homo OR@ (M)" min-width="155">
		</el-table-column>
		<el-table-column prop="riskHomoRiskF" label="Risk homo risk (F)" min-width="155">
		</el-table-column>
		<el-table-column prop="riskHomoOrF" label="Risk homo OR@ (F)" min-width="155">
		</el-table-column>
		<el-table-column prop="hetero" label="Hetero" min-width="95">
		</el-table-column>
		<el-table-column prop="heteroFreq" label="Hetero freq" min-width="100">
		</el-table-column>
		<el-table-column prop="heteroOr" label="Hetero OR" min-width="115">
		</el-table-column>
		<el-table-column prop="resultHetero" label="检测结果Hetero OR" min-width="160">
		</el-table-column>
		<el-table-column prop="heteroRiskM" label="Hetero risk (M)" min-width="135">
		</el-table-column>
		<el-table-column prop="heteroOrM" label="Hetero OR@ (M)" min-width="135">
		</el-table-column>
		<el-table-column prop="heteroRiskF" label="Hetero risk (F)" min-width="135">
		</el-table-column>
		<el-table-column prop="heteroOrF" label="Hetero OR@ (F)" min-width="135">
		</el-table-column>
		<el-table-column prop="wtHomo" label="WT homo" min-width="115">
		</el-table-column>
		<el-table-column prop="wtHomoFreq" label="WT homo freq" min-width="115">
		</el-table-column>
		<el-table-column prop="wtHomoOr" label="WT homo OR" min-width="115">
		</el-table-column>
		<el-table-column prop="resultWtHomo" label="检测结果WT homo OR" min-width="165">
		</el-table-column>
		<el-table-column prop="wtHomoRiskM" label="WT homo risk (M)" min-width="165">
		</el-table-column>
		<el-table-column prop="wtOrM" label="WT OR@ (M)" min-width="135">
		</el-table-column>
		<el-table-column prop="wtHomoRiskF" label="WT homo risk (F)" min-width="135">
		</el-table-column>
		<el-table-column prop="wtOrF" label="WT OR@ (F)" min-width="135">
		</el-table-column>
		<el-table-column prop="ldBlock" label="LD block" min-width="115">
		</el-table-column>
	</el-table>
	<el-table :data='this.tableData[0].lhLociParamList' stripe style="width: 100%" max-height="300" v-else>
		<el-table-column prop="detectionContent" label="检测内容" min-width="110">
		</el-table-column>
		<el-table-column prop="gene" label="基因" min-width="105">
		</el-table-column>
		<el-table-column prop="locus" label="多态位点" min-width="160">
		</el-table-column>
		<el-table-column prop="proofLevel" label="置信等级" min-width="90">
		</el-table-column>
		<el-table-column prop="geneType" label="基因型" min-width="105">
		</el-table-column>
		<el-table-column prop="cnProportion" label="中国人群占比" min-width="150" >
		</el-table-column>
		<el-table-column prop="detectionResult" label="检测结果" min-width="185">
		</el-table-column>
		<el-table-column prop="normalOrRisk" label="正常/风险" min-width="165">
		</el-table-column>
		<el-table-column prop="isKeyLocus" label="决定位点" min-width="130">
		</el-table-column>
		<el-table-column prop="suggestionShort" label="短建议" min-width="110">
		</el-table-column>
		<el-table-column prop="severity" label="关注度" min-width="160">
		</el-table-column>
		<el-table-column prop="suggestion" label="建议" min-width="90">
		</el-table-column>
		<el-table-column prop="suggestionCode" label="编号" min-width="115">
		</el-table-column>
	</el-table>
	<h3>建议列表：</h3>
	<el-table :data='this.tableData[0].lhSuggestionParamList' stripe style="width: 100%" max-height="200" border>
		<el-table-column prop="detectionItemNameCn" label="检测项" min-width="110">
		</el-table-column>
		<el-table-column prop="" label="编号" min-width="185">
			<template slot-scope="scope" >
				<div class="content-rowspan">
					<div v-for="(value,index) in scope.row.codesCombo" :key="index">
						<p>编号： {{ value.code }}</p>
						<p>决定位点： {{ value.isKeyLocus }}</p>
					</div>
				</div>
			</template>
		</el-table-column>
		<el-table-column prop="suggestion" label="建议" min-width="160">
		</el-table-column>
		<el-table-column prop="suggestionShort" label="短建议" min-width="90">
		</el-table-column>
		<el-table-column prop="suggestionSeverity" label="关注度" min-width="105">
		</el-table-column>
	</el-table>
	<h3>位点替换：</h3>
	<el-table :data='this.tableData[0].lhLociReplaceParamList' stripe style="width: 100%" max-height="300" border>
		<el-table-column prop="destGeneType" label="目标基因型" min-width="110">
		</el-table-column>
		<el-table-column prop="destGene" label="目标基因" min-width="160">
		</el-table-column>
		<el-table-column prop="destLoci" label="目标位点" min-width="90">
		</el-table-column>
		<el-table-column prop="" label="源位点" min-width="185">
			<template slot-scope="scope" >
				<div class="content-rowspan">
					<div v-for="(value,index) in scope.row.sourceLociInfo" :key="index">
						<p>源基因型： {{ value.geneType }}</p>
						<p>源位点： {{ value.loci }}</p>
					</div>
				</div>
			</template>
		</el-table-column>
		<el-table-column prop="replaceRule" label="替换方式" min-width="105">
		</el-table-column>
	</el-table>
</div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isLHAndRISK () {
      return this.tableData[0].riskLociParams && this.tableData[0].riskLociParams.length
    }
  }

}
</script>

<style lang="less">
.LH{
	.el-table{
		.content-rowspan{
			>div{
				border-bottom: 1px solid #e4e4e4;
			}
			>div:last-child{
				border-bottom: none;
			}
		}
	}
}

</style>
